import * as audioFiles from '../audio';

const mosMapping = {
  // VKOW
  1: audioFiles.BASE_VKOW_JTAN,
  2: audioFiles.PROPOSED_VKOW_JTAN,
  3: audioFiles.BASE_VKOW_JLEE,
  4: audioFiles.PROPOSED_VKOW_JLEE,
  5: audioFiles.PROPOSED_VKOW_SAMF,
  6: audioFiles.BASE_VKOW_SAMF,
  7: audioFiles.PROPOSED_VKOW_MPOL,
  8: audioFiles.BASE_VKOW_MPOL,
  9: audioFiles.BASE_VKOW_MPUR,
  10: audioFiles.PROPOSED_VKOW_MPUR,
  11: audioFiles.PROPOSED_VKOW_PMAR,
  12: audioFiles.BASE_VKOW_PMAR,

  // ADIZ
  13: audioFiles.PROPOSED_ADIZ_JTAN,
  14: audioFiles.BASE_ADIZ_JTAN,
  15: audioFiles.BASE_ADIZ_JLEE,
  16: audioFiles.PROPOSED_ADIZ_JLEE,
  17: audioFiles.BASE_ADIZ_SAMF,
  18: audioFiles.PROPOSED_ADIZ_SAMF,
  19: audioFiles.PROPOSED_ADIZ_MPOL,
  20: audioFiles.BASE_ADIZ_MPOL,
  21: audioFiles.PROPOSED_ADIZ_MPUR,
  22: audioFiles.BASE_ADIZ_MPUR,
  23: audioFiles.BASE_ADIZ_PMAR,
  24: audioFiles.PROPOSED_ADIZ_PMAR,

  // M1
  25: audioFiles.BASE_M1_JTAN,
  26: audioFiles.PROPOSED_TP_M1_JTAN,
  27: audioFiles.PROPOSED_TP_M1_JLEE,
  28: audioFiles.BASE_M1_JLEE,
  29: audioFiles.BASE_M1_SAMF,
  30: audioFiles.PROPOSED_TP_M1_SAMF,
  31: audioFiles.PROPOSED_TP_M1_MPOL,
  32: audioFiles.BASE_M1_MPOL,
  33: audioFiles.BASE_M1_MPUR,
  34: audioFiles.PROPOSED_TP_M1_MPUR,
  35: audioFiles.BASE_M1_PMAR,
  36: audioFiles.PROPOSED_TP_M1_PMAR,

  // F2
  37: audioFiles.PROPOSED_TP_F2_JTAN,
  38: audioFiles.BASE_F2_JTAN,
  39: audioFiles.BASE_F2_JLEE,
  40: audioFiles.PROPOSED_TP_F2_JLEE,
  41: audioFiles.PROPOSED_TP_F2_SAMF,
  42: audioFiles.BASE_F2_SAMF,
  43: audioFiles.BASE_F2_MPOL,
  44: audioFiles.PROPOSED_TP_F2_MPOL,
  45: audioFiles.PROPOSED_TP_F2_MPUR,
  46: audioFiles.BASE_F2_MPUR,
  47: audioFiles.PROPOSED_TP_F2_PMAR,
  48: audioFiles.BASE_F2_PMAR,
};

export default mosMapping;